<template>
    <div class="confirmationForm">
        <el-container>
            <el-main ref="main" style="padding: 0;overflow: hidden;">
                <div ref="HTMLPrintContent" id="HTMLSendContent"
                     style="width: 100%;height: 100%;padding-top:20px;box-sizing: border-box;">
                    <div style="display: flex;align-items: center;justify-content: center;font-size: 25px;font-weight: 600;">
                        <span>零星工程量确认单</span>
                    </div>
                    <div style="display: flex;justify-content: space-between;align-items: center;font-size: 18px;color:#000;margin-top: 18px">
                        <div style="display: flex;align-items: center;">
                            <div>施工单位：</div>
                            <div>{{projectInfo.partyB}}</div>
                        </div>
                        <div style="display: flex;align-items: center;">
                            <div>细目号：</div>
                            <div style="width: 100px;"></div>
                        </div>
                    </div>
                    <div style="border: 1px solid #000; font-size: 18px;color:#000;margin-top: 10px">
                        <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #000;">
                            <div style="width: 50%;height: 50px;border-right: 1px solid #000;display: flex;align-items: center;padding-left: 10px">
                                里程桩号：
                            </div>
                            <div style="width: 50%;height: 50px;display: flex;align-items: center;padding-left: 10px">
                                部位：
                            </div>
                        </div>
                        <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #000;">
                            <div style="width: 50%;height: 50px;border-right: 1px solid #000;display: flex;align-items: center;padding-left: 10px">
                                工程项目：{{projectInfo.projectName}}
                            </div>
                            <div style="width: 50%;height: 50px;display: flex;align-items: center;padding-left: 10px">
                                施工日期：
                            </div>
                        </div>
                        <div style="height: 350px;line-height: 50px;padding-left: 10px;border-bottom: 1px solid #000;">
                                计算、草图及说明：
                        </div>
                        <div style="height: 70px;display: flex;justify-content: space-between;border-bottom: 1px solid #000;">
                            <div style="padding: 10px 0 0 10px">
                                计算：
                            </div>
                            <div style="width: 300px;padding: 10px 0 0 10px">
                                项目部现场技术员：
                            </div>
                        </div>
                        <div style="height: 70px;display: flex;justify-content: space-between;border-bottom: 1px solid #000;">
                            <div style="padding: 10px 0 0 10px">
                                工程部意见：
                            </div>
                        </div>
                        <div style="height: 70px;display: flex;justify-content: space-between;border-bottom: 1px solid #000;">
                            <div style="padding: 10px 0 0 10px">
                                计划部意见：
                            </div>
                        </div>
                        <div style="height: 70px;display: flex;justify-content: space-between;border-bottom: 1px solid #000;">
                            <div style="padding: 10px 0 0 10px">
                                总工意见：
                            </div>
                        </div>
                        <div style="height: 70px;display: flex;justify-content: space-between;">
                            <div style="padding: 10px 0 0 10px">
                                项目经理意见：
                            </div>
                        </div>
                    </div>
                    <div style="padding: 10px 0 0 10px;font-size: 18px;color:#000;">
                        注： 此确认单必须经各部门及项目经理签字确认公司核准方可生效。
                    </div>
                </div>
            </el-main>

        </el-container>
    </div>
</template>

<script>
    export default {
        name: "confirmationForm",
        props:{
            projectInfo: {
                type: Object,
                default: () => {},
            },
        },
        watch: {
            projectInfo(value) {
                console.log(value)
            },
        }
    }
</script>

<style scoped lang="scss">
    .confirmationForm{
        width: 694px;
        /*height: 853px;*/
        height: 950px;
        /*border: 1px solid #000;*/
        margin: 20px auto 0px;
    }
</style>
